module.exports = __webpack_public_path__ + "static/media/androidLifecycle.ef1661da.png";